import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import * as api from "./../../api/api";
import { Link } from "react-router-dom";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, 0)",

    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#0d2da6",
    color: "white",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: 12,
    minHeight: 46,
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
    height: 46,
    "&$expanded": {
      minHeight: 46,
    },
  },
  content: {
    fontSize: 14,
    "&$expanded": {
      fontSize: "14px",
      margin: "12px 0",
      alignItems: "center",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    backgroundColor: "#f8f9fb",
    border: "1px solid #eee",
    padding: theme.spacing(2),
    marginBottom: 10,
    marginTop: -10,
  },
}))(MuiAccordionDetails);

export default function Body() {
  const [expanded, setExpanded] = React.useState("panel1");
  const [institutionalData, setInstitutionalData] = useState("");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    institutionalAPI();
  }, []);

  const institutionalAPI = async () => {
    try {
      let response = await api.institute();
      setInstitutionalData(response);
    } catch (e) {}
  };

  return (
    <div>
      <Accordion
        square
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography style={{ color: "white", textAlign: "right" }}>
            Site Navigation
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {/* //SITE NAVIGATION */}
            <ul className="">
              <Link to="/">
                <li>
                  <button className="border-0 bg-transparent">
                    <span className="rightSponsorButton">Home</span>
                  </button>
                </li>
              </Link>
              <Link to="/about-us">
                <li>
                  <button className="border-0 bg-transparent">
                    <span className="rightSponsorButton">
                      About 121five.com
                    </span>
                  </button>
                </li>
              </Link>
              <Link to="/search-news-and-features">
                <li>
                  <button className="border-0 bg-transparent">
                    <span className="rightSponsorButton">
                      Search News & Features
                    </span>
                  </button>
                </li>
              </Link>
              <Link to="/gallery">
                <li>
                  <button className="border-0 bg-transparent">
                    <span className="rightSponsorButton">
                      Photographer Galleries
                    </span>
                  </button>
                </li>
              </Link>
              <li>
                <a
                  href="https://www.translate.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Translate
                </a>
              </li>
              <Link to="/contact-us">
                <li>
                  <button className="border-0 bg-transparent">
                    <span className="rightSponsorButton">
                      Contact Information
                    </span>
                  </button>
                </li>
              </Link>

              <li>
                <a
                  href="https://aerovents.com/body.shtml"
                  target="_blank"
                  rel="noreferrer"
                >
                  AeroVents.com Calendar
                </a>
              </li>

              <li>
                <a href="/login" target="_blank" rel="noreferrer">
                  Sponsor Portal
                </a>
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        square
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography style={{ color: "white" }}>
            Institutional Information
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {Object.keys(institutionalData).map((index) => {
              return (
                <ul>
                  <a
                    href={institutionalData[index].url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li>{institutionalData[index].title}</li>
                  </a>
                </ul>
              );
            })}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
